import PropTypes from 'prop-types';
import { FormikDate } from '@febos-io/design';
import { useTranslation } from "../../../hooks";
import { InputProps } from "./types";


export function Item({
  name,
  config
}:InputProps) {
  const { t } = useTranslation();

  return (
    <FormikDate
      name={name}
      label={`${t(config.name)}`}
      placeholder={`${t(config.name)}`}
    />
  );
}

Item.propTypes = {
  name: PropTypes.string,
  config: PropTypes.object
};

export default Item;
